import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\wonde\\Downloads\\stellarscholar (9)\\stellarscholar\\node_modules\\next\\dist\\client\\app-dir\\link.js");
